import React from 'react';
import ApproachWrapper from '@modules/insights/integrationApproach/approachWrapper';
import { API } from '@service';
import { SEPARATION_APPROACH_TITLE } from '@model';
import { SEPARATION_APPROACH } from '@modules/insights/insightsDropdown';

function SeparationApproach(props) {
  return (
    <ApproachWrapper
      // title={SEPARATION_APPROACH_TITLE}
      fetchService={API.getSeparationApproach}
      saveService={API.postSeparationApproach}
      insightSectionKey={SEPARATION_APPROACH}
      sectionName="Separation"
      {...props}
    />
  );
}

export default SeparationApproach;
